import en_companyProfile from "../../page/company_profile/language/en_companyProfile"
import en_dashboard from "../../page/dashboard/language/en_dashboard"
import en_login from "../../page/login/language/en_login"
import en_master_attribute from "../../page/master/attribute/language/en_master_attribute"
import en_master_bankaccount from "../../page/master/bank_account/language/en_master_bankaccount"
import en_master_convertion from "../../page/master/conversion/language/en_master_convertion"
import en_master_courier from "../../page/master/courier/language/en_master_courier"
import en_master_customer from "../../page/master/customer/language/en_master_customer"
import en_master_finance from "../../page/master/finance/language/en_master_finance"
import en_master_goods from "../../page/master/goods/language/en_master_goods"
import en_master_goodsPrice from "../../page/master/goods/price/language/en_master_goodsPrice"
import en_master_goodsPriceTier from "../../page/master/goods/price_tier/language/en_master_goodsPriceTier"
import en_master_groups from "../../page/master/grouping/language/en_master_groups"
import en_master_itemtag from "../../page/master/item_tag/language/en_master_itemtag"
import en_master_payment_method from "../../page/master/payment_method/language/en_master_payment_method"
import en_master_price_tier from "../../page/master/price_tier/language/en_master_price_tier"
import en_master_process from "../../page/master/process/language/en_master_process"
import en_master_profile from "../../page/master/profile/language/en_master_profile"
import en_master_supplier from "../../page/master/supplier/language/en_master_supplier"
import en_master_tnc_setting from "../../page/master/tnc_setting/language/en_master_tnc_setting"
import en_master_category from "../../page/master/unit_category/language/en_master_category"
import en_master_unit from "../../page/master/unit_category/language/en_master_unit"
import en_master_user from "../../page/master/user/language/en_master_user"
import en_master_storage from "../../page/master/warehouse/language/en_master_storage"
import en_master_whs_setting from "../../page/master/warehouse/language/en_master_whs_setting"
import en_mitra from "../../page/mitra/language/en_mitra"
import en_mitra_list from "../../page/mitra/list/language/en_mitra_list"
import en_mitra_stock_req from "../../page/mitra/stock_request/language/en_mitra_stock_req"
import en_payment_credit from "../../page/payment/credit/language/en_payment_credit"
import en_payment_debit from "../../page/payment/debit/language/en_payment_debit"
import en_purch_invoice from "../../page/purchase/invoice/language/en_purch_invoice"
import en_purch_po from "../../page/purchase/po/language/en_purch_po"
import en_purch_poMitra from "../../page/purchase/po_mitra/language/en_purch_poMitra"
import en_purch_quotation from "../../page/purchase/quotation/language/en_purch_quotation"
import en_purch_quotationMitra from "../../page/purchase/quotation_mitra/language/en_purch_quotationMitra"
import en_purch_quotationSales from "../../page/purchase/quotation_sales/language/en_purch_quotationSales"
import en_purch_recap from "../../page/purchase/recap/language/en_purch_recap"
import en_sales_refItemIn from "../../page/purchase/ref_item_in/language/en_sales_refItemIn"
import en_purch_returnsupplier from "../../page/purchase/return_supplier/language/en_purch_returnsupplier"
import en_rka_planning from "../../page/rka/planning/language/en_rka_planning"
import en_sales_invoice from "../../page/sales/invoice/language/en_sales_invoice"
import en_sales_po from "../../page/sales/po/language/en_sales_po"
import en_sales_quotation from "../../page/sales/quotation/language/en_sales_quotation"
import en_sales_quotationMitra from "../../page/sales/quotation_mitra/language/en_sales_quotationMitra"
import en_sales_recap from "../../page/sales/recap/language/en_sales_recap"
import en_sales_refItemOut from "../../page/sales/ref_item_out/language/en_sales_refItemOut"
import en_sales_returncustomer from "../../page/sales/return_customer/language/en_sales_returncustomer"
import en_sales_so from "../../page/sales/so/language/en_sales_so"
import en_supplychain_distributionPoint from "../../page/supplychain/distribution_point/language/en_supplychain_distributionPoint"
import en_supplychain_itemReq from "../../page/supplychain/item_request/language/en_supplychain_itemReq"
import en_supplychain_do from "../../page/supplychain/language/en_supplychain_do"
import en_template from "../../page/template/language/en_template"
import en_trans_convertion from "../../page/transaction/conversion/language/en_trans_convertion"
import en_trans_initstock from "../../page/transaction/init_stock/language/en_trans_initstock"
import en_trans_itemin from "../../page/transaction/item_in/language/en_trans_itemin"
import en_trans_itemmove from "../../page/transaction/item_move/language/en_trans_itemmove"
import en_trans_itemout from "../../page/transaction/item_out/language/en_trans_itemout"
import en_trans_common from "../../page/transaction/language/en_trans_common"
import en_trans_iteminlist from "../../page/transaction/list_item_in/language/en_trans_iteminlist"
import en_trans_itemoutlist from "../../page/transaction/list_item_out/language/en_trans_itemoutlist"
import en_trans_production from "../../page/transaction/production/language/en_trans_production"
import en_trans_returncuslist from "../../page/transaction/return_customer/language/en_trans_returncuslist"
import en_trans_returnsuplist from "../../page/transaction/return_supplier/language/en_trans_returnsuplist"
import en_trans_stockopname from "../../page/transaction/stock_opname/language/en_trans_stockopname"
import en_whs_itemin from "../../page/warehouse/item_in/language/en_whs_itemin"
import en_whs_itemmove from "../../page/warehouse/item_move/language/en_whs_itemmove"
import en_whs_itemout from "../../page/warehouse/item_out/language/en_whs_itemout"
import en_whs_itemstock from "../../page/warehouse/item_stock/language/en_whs_itemstock"
import en_whs_returncus from "../../page/warehouse/return_customer/language/en_whs_returncus"
import en_whs_returnsup from "../../page/warehouse/return_supplier/language/en_whs_returnsup"
import en_whs_serialnumber from "../../page/warehouse/serial_number/language/en_whs_serialnumber"
import en_whs_goodsdetail from "../../page/warehouse/warehouse_goods_detail/language/en_whs_goodsdetail"
import en_common from "./common/common_en"
import common_error_en from "./common_error/common_error_en"
import common_message_en from "./common_message/common_message_en"

const main_en_language = {
	translation: {
		common: en_common,
		common_error: common_error_en,
		common_msg: common_message_en,

		company_profile: en_companyProfile,
		crop_img: { crop: "crop", ok: "crop image" },
		dashboard: en_dashboard,
		login: en_login,

		menu: {
			dashboard: "dashboard",
			warehouse: "warehouse check",
			whstrans: "warehouse transaction",
			master: "settings",
			sales: "sales",
			ecommerce: "online store",
			ecommregister: "1Store registration",
			ecommlist: "online store list",
			payment: "payment",
			purchase: "purchase",
			supplychain: "supply chain",
			supplychain_point: "distribution point",
			supplychain_request: "item request",
			report: "report",
			rka: "planning & budgeting",
			groups: "item groups",
		},

		// mitra
		mitra: en_mitra,
		mitra_list: en_mitra_list,
		mitra_stock_req: en_mitra_stock_req,

		// master
		master_attribute: en_master_attribute,
		master_bankaccount: en_master_bankaccount,
		master_category: en_master_category,
		master_convertion: en_master_convertion,
		master_courier: en_master_courier,
		master_customer: en_master_customer,
		master_finance: en_master_finance,
		master_goods: en_master_goods,
		master_goodsPrice: en_master_goodsPrice,
		master_goodsPriceTier: en_master_goodsPriceTier,
		master_groups: en_master_groups,
		master_itemtag: en_master_itemtag,
		master_payment_method: en_master_payment_method,
		master_price_tier: en_master_price_tier,
		master_process: en_master_process,
		master_profile: en_master_profile,
		master_supplier: en_master_supplier,
		master_storage: en_master_storage,
		master_tncsetting: en_master_tnc_setting,
		master_unit: en_master_unit,
		master_user: en_master_user,
		master_whssetting: en_master_whs_setting,
		master: {
			sales: {
				add: "add sales",
				edit: "edit sales",
			},
			brand: {
				// "": "brand",
				// "name": "brand name",
				// add: "add brand",
				// edit: "edit brand",
				"": "principal",
				"name": "principal name",
				add: "add principal",
				edit: "edit principal",
			}
		},

		// contract
		spal: {
			addspal: "add contract",
			editspal: "edit contract",
			addpaymentmethod: "add payment method ( contract )",
			editpaymentmethod: "edit payment method ( contract )",
			addtime: "add load & unload time ( contract )",
			edittime: "edit load & unload time ( contract )",
			adddemurrage: "add late charge ( contract )",
			editdemurrage: "edit late charge ( contract )",
			form: {
				paymentmethod: "payment method",
				demurrage: "late charge",
				time: "load & unload time",
			},
		},

		// supplychain
		supplychain_distributionPoint: en_supplychain_distributionPoint,
		supplychain_do: en_supplychain_do,
		supplychain_itemReq: en_supplychain_itemReq,

		// transaction
		trans_common: en_trans_common,
		trans_convertion: en_trans_convertion,
		trans_initstock: en_trans_initstock,
		trans_itemin: en_trans_itemin,
		trans_iteminlist: en_trans_iteminlist,
		trans_itemmove: en_trans_itemmove,
		trans_itemout: en_trans_itemout,
		trans_itemoutlist: en_trans_itemoutlist,
		trans_production: en_trans_production,
		trans_returncuslist: en_trans_returncuslist,
		trans_returnsuplist: en_trans_returnsuplist,
		trans_stockopname: en_trans_stockopname,

		// sales
		sales_invoice: en_sales_invoice,
		sales_po: en_sales_po,
		sales_recap: en_sales_recap,
		sales_refItemOut: en_sales_refItemOut,
		sales_returncustomer: en_sales_returncustomer,
		sales_so: en_sales_so,
		sales_quotation: en_sales_quotation,
		sales_quotationMitra: en_sales_quotationMitra,

		// purch
		purch_invoice: en_purch_invoice,
		purch_po: en_purch_po,
		purch_poMitra: en_purch_poMitra,
		purch_recap: en_purch_recap,
		sales_refItemIn: en_sales_refItemIn,
		purch_returnsupplier: en_purch_returnsupplier,
		purch_quotation: en_purch_quotation,
		purch_quotationMitra: en_purch_quotationMitra,
		purch_quotationSales: en_purch_quotationSales,

		// payment
		payment_credit: en_payment_credit,
		payment_debit: en_payment_debit,

		report: {},

		// rka
		rka_planning: en_rka_planning,

		// template
		template: en_template,

		// warehouse
		whs_itemin: en_whs_itemin,
		whs_itemmove: en_whs_itemmove,
		whs_itemout: en_whs_itemout,
		whs_itemstock: en_whs_itemstock,
		whs_returncus: en_whs_returncus,
		whs_returnsup: en_whs_returnsup,
		whs_serialnumber: en_whs_serialnumber,
		whs_goodsdetail: en_whs_goodsdetail,
	},
}

export default main_en_language
